import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

import type { RouterContext } from '@shared/config/router-context';
import { canAccessCrmCustomerDirectory } from '@shared/lib';

/** Old Search bookmarks and Profile return links enter the single Users search. */
export const Route = createFileRoute('/$locale/_authenticated/crm/search')({
  validateSearch: z.object({
    page: z.coerce.number().int().positive().max(100_000).optional(),
    q: z.string().trim().min(1).max(200).optional(),
  }),
  beforeLoad: ({ context, params, search }) => {
    const { auth, ability } = context as RouterContext;
    if (!auth.isLoading && auth.isAuthenticated && !canAccessCrmCustomerDirectory(ability)) {
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({ to: '/$locale/unauthorized', params: { locale: params.locale } });
    }
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({
      to: '/$locale/crm',
      params: { locale: params.locale },
      search: search.q ? { q: search.q } : {},
      replace: true,
    });
  },
});
